import { render, staticRenderFns } from "./DsSaveBar.vue?vue&type=template&id=a1922158&scoped=true&"
import script from "./DsSaveBar.vue?vue&type=script&lang=js&"
export * from "./DsSaveBar.vue?vue&type=script&lang=js&"
import style0 from "./DsSaveBar.vue?vue&type=style&index=0&id=a1922158&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1922158",
  null
  
)

export default component.exports